import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=41814f77&scoped=true&"
import script from "./TableBox.vue?vue&type=script&lang=js&"
export * from "./TableBox.vue?vue&type=script&lang=js&"
import style0 from "./TableBox.vue?vue&type=style&index=0&id=41814f77&lang=scss&scoped=true&"
import style1 from "./TableBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41814f77",
  null
  
)

export default component.exports